import { ErrorMessage } from "@/common/components";

export function Forbidden() {
  return (
    <ErrorMessage
      title="Доступ к странице запрещен"
      description="Вернитесь назад или обратитесь к администратору"
    />
  );
}
